import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { SideNav as SideNavStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import IconButton from '../IconButton'
import { CommonProps } from '../helperTypes'

const useStyles = createUseStyles(SideNavStyles, 'sidenav')

type Props = PropsWithChildren<{
  /** Called when the SideNav closes */
  onClose?: () => void
}>

type SideNavTitleProps = Props & CommonProps

const SideNavTitle = (props: SideNavTitleProps) => {
  const { children, className, onClose, ...rest } = props
  const classes = useStyles()
  return (
    <div className={clsx(className, classes.titleSection)} {...rest}>
      <h4 className={classes.title}>{children}</h4>
      <IconButton variant='ghost' className={classes.close} onClick={onClose} />
    </div>
  )
}

export default SideNavTitle
